<template>
  <el-date-picker
    ref="input"
    v-model="model"
    type="datetime"
    :placeholder="placeholder"
    :format="format"
    :clearable="clearable"
    :class="optionClass"
    :disabled="computedDisabled"
    @click.native="onClick($event)"
    @keydown.esc.native="onEscKey($event)"
    @keydown.down.native="onDownKey($event)"
    @keydown.enter.capture.native="onEnterKey($event)"
    @focus="onFocus"
    @blur="onBlur"
    @change="onChange">
  </el-date-picker>
</template>

<script>
/* 日付の入力要素(modelはstring型) */
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppInputComponent from './AppInputComponent';
import moment from 'moment';

@Component
export default class AppInputDateTime extends AppInputComponent {
  /**
   * v-model対応
   */
  get model () {
    if (this.value !== null) {
      return moment(this.value, this.modelFormat).toDate();
    } else {
      return null;
    }
  }

  /**
   * v-model対応
   */
  set model (value) {
    if (value !== null) {
      this.$emit('input', moment(value).format(this.modelFormat));
    } else {
      this.$emit('input', value);
    }
  }

  // 表示用のフォーマット
  get format () {
    return (this.options && 'format' in this.options) ? this.options.format : this.$t('common.format.datetime');
  }

  // モデルの日付フォーマット
  get modelFormat () {
    return (this.options && 'modelFormat' in this.options) ? this.options.modelFormat : 'YYYY/MM/DD HH:mm:ss';
  }

  /**
   * デフォルトサイズ
   */
  get defaultSize () {
    return 'medium';
  }

  /**
   * フォーカス設定時イベント
   */
  onFocus (...args) {
    // フォーカス時に自動でpickerが開かないように制御する
    this.$nextTick().then(() => {
      this.$refs.input.picker.visible = false;
    });
    this.$emit('app-event', 'focus', this, ...args);
  }

  /**
   * 下方向キー押下イベント
   */
  onDownKey (...args) {
    // 下キー押下時にpickerを展開する
    if (this.$refs.input.picker.visible !== true) {
      this.$refs.input.showPicker();
    }
  }

  /**
   * ESCキー押下イベント
   */
  onEscKey (...args) {
    // フォーカスを再設定する
    this.$nextTick().then(() => {
      this.$refs.input.focus();
    });
  }

  /**
   * エンターキー押下イベント
   */
  onEnterKey (...args) {
    // pickerが展開中の場合は（elコンポーネント側の）値確定処理のみ実施してフォーカスを再設定する
    if (this.$refs.input.picker.visible) {
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    } else {
      this.$nextTick().then(() => {
        this.$emit('app-event', 'enterkey', event, this);
      });
    }
  }

  /**
   * クリック時イベント
   */
  onClick (...args) {
    // フォーカスでpickerを展開しないよう修正したのでクリック時には明示的に展開する
    if (this.$refs.input.disabled) {
      return;
    }
    if (this.$refs.input.picker.visible !== true) {
      this.$refs.input.showPicker();
    }
  }

  // 親コンポーネントへの透過イベント
  onChange (...args) {
    this.$emit('app-event', 'change', this, ...args);

    // 値が変更されたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }

  /**
   * DatePickerの変更イベント発火
   */
  blur () {
    this.$refs.input.pickerVisible = false;
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/input/AppInputDateTime.vue